export default __webpack_public_path__ + "static/media/TNGRRLUMA-U024NGNS9N2-a14fc31b9b1c-512.199128a5.jpg";